const constants = {
    defaultAnimationTimeout: 220,
    slowAnimationTimeout: 350,
    defaultTransition: 'all .22s ease-in-out',
    slowTransition: 'all .35s ease-in-out',
}

module.exports = constants;